import { render, staticRenderFns } from "./TabButtons.vue?vue&type=template&id=092091f3&lang=html&"
import script from "./TabButtons.vue?vue&type=script&lang=js&"
export * from "./TabButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports